'use strict';

// External dependencies
import 'jquery';
import 'bootstrap';
import 'lazysizes';

// Constants
import './components/constants/class';
import './components/constants/silver-decisions';

// Components
import './components/common';
import './components/toolbar-toggle';
import './components/accordion';
import './components/node-accordion';
//import './components/register-serviceworker';
import './components/silver-decision-extensions';
import './components/settings-accordion';
import './components/range-slider';
//import './components/sensitivity';
import './components/tab-menu';

import './components/convolution';
import './components/showChart';
import './components/payoffs';

import './components/custom-hooks';



// WEBPACK FOOTER //
// ./scripts/scripts.js